import { lazy } from 'react';

const ApplyPaymentSubscriptionsConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/subscriptions/apply-payment-view/:compacctnum/:billId',
      component: lazy(() => import('./ApplyPaymentViewSubscriptions')),
    },
    {
      path: '/subscriptions/apply-payment-view/:compacctnum',
      component: lazy(() => import('./ApplyPaymentViewSubscriptions')),
    },
    {
      path: '/subscriptions/confirm-payment/:id',
      component: lazy(() => import('./ConfirmPayment')),
    },
  ],
};

export default ApplyPaymentSubscriptionsConfig;
